import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PRICING_DEFAULTS = {
  three_day_package: 222, additional_day_rate: 75, weekly_special: 375,
  allin_coverage_day: 25, damage_waiver_day: 15, young_driver_day: 25,
  additional_driver_day: 15, weekly_savings: 147,
};

let cache = null;

export function usePublicPricing() {
  const [pricing, setPricing] = useState(cache || PRICING_DEFAULTS);
  useEffect(() => {
    if (cache) return;
    axios.get(`${API}/pricing/public`).then((r) => { cache = r.data; setPricing(r.data); }).catch(() => {});
  }, []);
  return pricing;
}

export const packageBase = (p, days) => {
  const d = Math.max(1, days || 1);
  if (d >= 7) return p.weekly_special + Math.max(0, d - 7) * p.additional_day_rate;
  return p.three_day_package + Math.max(0, d - 3) * p.additional_day_rate;
};
